<h4 class="followup-title">{{ "create_scheduler" | langVal }}</h4>
<div class="row form-group">
	<app-gen-button-group
		[actualObj]="data"
		fieldName="is_fixed_interval"
		optionsListName="is_fixed_interval_opts"
		(changeEvent)="changeInterval()"
	/>
	<div class="colstat colstat-big">
		<label>{{ "start_date" | langVal }}</label>
		<app-date-picker
			[actualObj]="data"
			fieldName="start_date"
			[errors]="errors"
			title_ph_lang="start_date"
			(changeEvent)="handleDateChange()"
		/>
	</div>
	@if (data.is_fixed_interval === "yes") {
		<div class="colstat colstat-big">
			<label>{{ "interval" | langVal }}</label>
			<app-gen-input
				[actualObj]="data"
				fieldName="interval"
				[errors]="errors"
				min="1"
				isNumber
				title_ph_lang="interval"
				(changeEvent)="validateEntireForm()"
				(keyupEvent)="validateEntireForm()"
			/>
		</div>
		<div class="colstat colstat-big">
			<label>{{ "repetitions" | langVal }}</label>
			<app-gen-input
				[actualObj]="data"
				fieldName="repetitions"
				[errors]="errors"
				min="1"
				isNumber
				title_ph_lang="repetitions"
				(changeEvent)="validateEntireForm()"
				(keyupEvent)="validateEntireForm()"
			/>
		</div>
	} @else {
		<div class="colstat colstat-big">
			<days
				[arr]="data.daysArr"
				[initDate]="data.start_date"
				(onChange)="handleDaysArrChange($event)"
				(onError)="handleDaysError($event)"
			/>
			<app-btn-ext
				text="once_more"
				(clickEv)="addDaysArrRow()"
			/>
		</div>
	}
	<div class="row form-group">
		<div class="bottom-row-buttons mb-2">
			<app-btn-ext
				text="submit"
				[isSpin]="isSaving"
				[disabled]="!isFormSubmittable"
				(clickEv)="handleSubmit()"
			/>
		</div>
	</div>
</div>
@if (isModalOpen) {
	<app-modal-wrap
		(onClose)="isModalOpen = false"
		title="contactways"
		modalWrapperClass="modal-800"
	>
		<app-gen-table-display
			(onClose)="
				isModalOpen = false; $event?.length && handleContactwaysClose($event)
			"
			tableName="contactways"
			filterField="patient_id"
			[filterFieldValue]="patient_id"
			fieldNameInItemToDisplay="contactway"
			isCheckItems
			[filterFieldOrs]="{ contactway_identifier: ['email', 'phone'] }"
		/>
	</app-modal-wrap>
}
